import type { ColumnTone } from '@vd/types';
import styles from './ColumnDot.module.css';

/**
 * A column's colour dot, by its role on the board (`columnTone` in
 * @vd/types): the first green, the last grey, those between blue, amber,
 * violet. Drawn beside each column in the column menus, on the board and the
 * ticket, on the table's column pill and the Filter dialog's column chips;
 * the board card's pill and the column headers use the same colours.
 */
export function ColumnDot({ tone, size }: { tone?: ColumnTone; size?: number }) {
  return <span className={styles.dot} data-tone={tone ?? 'neutral'} style={size ? { width: size, height: size } : undefined} aria-hidden />;
}
